<div class="header">
  <div class="title">
    {{ selectedFile.name }}
  </div>

  <ts-button
    class="close-button"
    type="icon"
    htmlButtonType="button"
    icon="ts_close"
    (buttonClick)="discard()"
    [tabIndex]="-1"
  ></ts-button>
</div>
<div class="flex flex-wrap h-full">
  <div
    [class]="
      expandRightSidebar ? 'flex flex-wrap w-3/4 lt-xl:w-full border-right' : 'flex flex-wrap lt-xl:w-full border-right'
    "
    [style]="expandRightSidebar ? '' : 'width: calc(100% - 60px)'"
  >
    <!-- WOPI File Editor -->
    @if (selectedFile) {
      <!-- If there are errors do not display the form. -->
      @if (selectedFile.wopi && !selectedFile.wopi.errors && editWopiFile) {
        <form
          [action]="selectedFile?.wopi?.edit_url || selectedFile?.wopi?.view_url"
          class="p-0 mb-6"
          id="officeForm"
          method="post"
          name="officeForm"
          target="officeFrame"
        >
          <input [value]="selectedFile?.wopi?.access_token" name="access_token" type="hidden" />
          <input [value]="selectedFile?.wopi?.access_token_ttl" name="access_token_ttl" type="hidden" />
          <input [value]="selectedFile?.wopi?.owner_id" name="owner_id" type="hidden" />
          <input [value]="selectedFile?.wopi?.user_id" name="user_id" type="hidden" />
        </form>

        <iframe
          [style]="editWopiFile ? 'height: 100%' : 'height: 0;'"
          allowfullscreen="true"
          class="bg-white"
          id="officeFrame"
          name="officeFrame"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
          title="Office Frame"
        ></iframe>
      }

      <!-- If there are errors and we are in edit mode then display the errors. -->
      @if (editWopiFile && selectedFile.wopi && selectedFile.wopi.errors) {
        <div class="mt-16 pl-8 pt-4">
          @for (error of selectedFile.wopi.errors; track error) {
            <p>
              <strong>{{ error }}</strong>
            </p>
          }
        </div>
      }

      <!-- If the file has no WOPI config at all, show a placeholder instead of a blank screen. -->
      @if (editWopiFile && !selectedFile.wopi) {
        <div class="file-preview-placeholder flex flex-col items-center justify-center w-full h-full p-8">
          <div class="text-center mb-4">
            <h3 class="text-xl font-medium mb-2">{{ selectedFile.name }}</h3>
            <p>This file type cannot be edited directly in the browser.</p>
          </div>
          <div class="flex gap-4">
            <ts-button variant="secondary" (buttonClick)="downloadDocument(selectedDocument)">Download File</ts-button>
          </div>
        </div>
      }
    }

    <ng-container *ngIf="selectedDocument && !editWopiFile">
      <ng-container *ngIf="!selectedDocument.pdf_url && selectedDocument.integrated_storage === 'one_drive'">
        <div class="flex flex-wrap w-full items-center justify-center">
          <ts-button
            variant="primary"
            class="send-button"
            id="add-project-finish-button"
            (buttonClick)="openOnline(selectedDocument)"
          >
            Open In Office Online
          </ts-button>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedDocument.pdf_url">
        <div class="pdf-viewer-container">
          <iframe
            [src]="selectedDocument.pdf_url | safe"
            style="display: block; width: 100%; height: 100%"
            id="pdf-viewer"
          ></iframe>

          @if (selectedFile.wopi && !selectedFile.wopi.errors) {
            <ts-button
              type="fab"
              color="primary"
              class="wopi-edit-fab"
              htmlButtonType="button"
              icon="edit"
              (buttonClick)="toggleWopiFile()"
            ></ts-button>
          }
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div
    [class]="expandRightSidebar ? 'flex flex-auto flex-col w-1/4 side-panel' : 'flex flex-auto flex-col side-panel'"
    [style]="expandRightSidebar ? '' : 'width: 60px'"
  >
    <div class="flex flex-col flex-auto">
      <div class="flex items-center px-3 pt-2 pb-1">
        <div class="flex flex-col">
          <div class="font-bold text-md text-secondary uppercase tracking-wider">
            {{ expandRightSidebar ? selectedFile.name : '' }}
          </div>
        </div>
        @if (expandRightSidebar) {
          <ts-button htmlButtonType="button" type="icon" [matMenuTriggerFor]="moreMenu" svgIcon="more_vert"></ts-button>
        }
        <ts-button
          htmlButtonType="button"
          type="icon"
          class="collapse-right-sidebar icon"
          (buttonClick)="expandRightSidebar = !expandRightSidebar"
          [svgIcon]="expandRightSidebar ? 'chevron_left' : 'chevron_right'"
        ></ts-button>
      </div>

      <div [class]="expandRightSidebar ? 'flex flex-col overflow-auto pl-3 pr-5' : 'hidden'">
        @if (tabs) {
          <ts-tab-group [tabs]="tabs" />
        }
        <ng-template #localDocsTemplate>
          <table class="w-full bg-transparent" mat-table [dataSource]="localDocumentsDataSource" [trackBy]="trackByFn">
            <ng-container matColumnDef="version">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Version</span>
              </th>
              <td mat-cell *matCellDef="let document; let i = index">
                <div class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                  <a (click)="setSelectedDocument(document)">
                    <div class="flex flex-row">
                      <div class="mt-1" style="text-decoration: underline">
                        Version {{ localDocumentsDataSource.data.length - i }}
                      </div>
                    </div>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="assetable_category_label">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Category</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  {{ document.assetable_category_label ?? '' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="created_by">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Created By</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  {{ document.created_by ? document.created_by.full_name : '' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Date</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  {{ document.created_at | date: 'LLL dd, y h:mm a' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Actions</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  <ts-button
                    htmlButtonType="button"
                    type="icon"
                    class="delete-file"
                    (buttonClick)="deleteDocument(document)"
                    svgIcon="delete"
                  ></ts-button>
                  <ts-button
                    htmlButtonType="button"
                    type="icon"
                    class="icon"
                    (buttonClick)="downloadDocument(document)"
                    svgIcon="get_app"
                  ></ts-button>
                  <ts-button
                    htmlButtonType="button"
                    type="icon"
                    class="icon"
                    [class]="editWopiFile ? 'edit-file' : 'view-file'"
                    (buttonClick)="toggleWopiFile()"
                    [svgIcon]="editWopiFile ? 'picture_as_pdf' : 'edit'"
                  ></ts-button>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="documentVersionsTableFooter">
              <td class="px-3 border-none" mat-footer-cell *matFooterCellDef colspan="6">
                <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
                <ts-button type="stroked" (buttonClick)="fileInput.click()"> Upload New File Version </ts-button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="localDocumentsColumns"></tr>
            <tr class="order-row h-16" mat-row *matRowDef="let row; columns: localDocumentsColumns"></tr>
            <tr class="py-3" mat-footer-row *matFooterRowDef="['documentVersionsTableFooter']"></tr>
          </table>
        </ng-template>

        <ng-template #integrationDocsTemplate>
          <table
            class="w-full bg-transparent"
            mat-table
            [dataSource]="integrationDocumentsDataSource"
            [trackBy]="trackByFn"
          >
            <ng-container matColumnDef="version">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Version</span>
              </th>
              <td mat-cell *matCellDef="let document; let i = index">
                <div class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                  <a (click)="setSelectedDocument(document)">
                    <div class="flex flex-row">
                      <div class="mt-1" style="text-decoration: underline">
                        Version {{ integrationDocumentsDataSource.data.length - i }}
                      </div>
                    </div>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="integrated_storage">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Storage</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  {{ document.integrated_storage ?? '' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="created_by">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Created By</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  {{ document.created_by ? document.created_by.full_name : '' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Date</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  {{ document.created_at | date: 'LLL dd, y h:mm a' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Actions</span>
              </th>
              <td mat-cell *matCellDef="let document">
                <span class="font-medium text-sm text-secondary whitespace-nowrap">
                  <ts-button
                    htmlButtonType="button"
                    type="icon"
                    class="icon"
                    (buttonClick)="downloadDocument(document)"
                    svgIcon="get_app"
                  ></ts-button>
                </span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="integrationDocumentsColumns"></tr>
            <tr class="order-row h-16" mat-row *matRowDef="let row; columns: integrationDocumentsColumns"></tr>
          </table>
        </ng-template>
      </div>

      <div class="w-full pl-3 pr-5" [class]="expandRightSidebar ? 'mt-3' : 'hidden'">
        <comment-view [relatedToId]="selectedFile.id" relatedToType="FileResource" [account]="account"></comment-view>
      </div>
    </div>
  </div>
</div>

<mat-menu #moreMenu="matMenu">
  <button mat-menu-item (click)="deleteFile()">
    <mat-icon [svgIcon]="'delete'"></mat-icon>
    <span>Delete</span>
  </button>
</mat-menu>
